import { useEffect } from 'react';
import { useToast } from '@shared/hooks/useToast';
import { ErrorHandler } from '@shared/services/errorHandler';
import { useTranslation } from 'react-i18next';

export const useErrorHandler = () => {
  const { showToast } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    ErrorHandler.setToastProvider({
      error: (message: string) => {
        const translatedMessage = message.startsWith('errors.') ? t(message) : message;
        showToast(translatedMessage, 'error');
      },
    });
  }, [showToast, t]);
};
